//--------------- EXPORT DO UTILITÁRIO FORMATTER CURRENCY ---------------//
// Responsável por formatar um valor em reais (R$ 00.000,00)
export default function formatterCurrency(value) {
  if (value === null || value === undefined || isNaN(value)) return "R$ 0,00";

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value));
}
